import styled from "@emotion/styled";
import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
import { sizes } from "../../../constants/spacing";
import { TypeRampV2 } from "../../typography";
export const labelVariantProps = themed({
  "lodestar-light": "bodyStrong",
  "ursa-light": "Inter--12px--600w"
});
export const labelStyles = themed({
  color: {
    rest: {
      "lodestar-light": color("color--text--neutral--default"),
      "ursa-light": color("color--text--neutral--strong")
    },
    error: {
      "lodestar-light": color("color--text--error--weak"),
      "ursa-light": color("color--text--neutral--strong")
    }
  },
  margin: {
    "lodestar-light": sizes.xSmall,
    "ursa-light": sizes.xxSmall
  }
});
export const FormLabelLabel = styled(TypeRampV2)`
    display: flex;
    margin-bottom: ${_ref => {
  let {
    themeMode
  } = _ref;
  return labelStyles.margin(themeMode);
}}px;
    color: ${_ref2 => {
  let {
    themeMode,
    validationState
  } = _ref2;
  return validationState === "error" ? labelStyles.color.error(themeMode) : labelStyles.color.rest(themeMode);
}};
`;
//# sourceMappingURL=FormLabelLabel.js.map